// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__1M0DY","row":"Node_row__2CU2u","label":"Node_label__MJsOz","footer":"Node_footer__25QJn"};